const userAgent = navigator.userAgent;

export const isXiaoMi = !!userAgent.match(/MI|Mi|Xiaomi|XiaoMi/);

export const isHuaWei = !!userAgent.match(/huawei/i);

export const isVivo = !!userAgent.match(/vivo/i);

export const isOppo = !!userAgent.match(/oppo/i);
